import React from 'react'
import {Card} from "react-bootstrap";

const TeamCard = (props) => {
    return (
        <Card>
            <Card.Img variant="top" src={props.teamImage} />
            <Card.Body>
                <Card.Title className="text-center">{props.teamName}</Card.Title>
                <Card.Text>
                    {props.teamBio}
                </Card.Text>
            </Card.Body>
            <Card.Footer>
                <div>{props.teamLearnMore}</div>
            </Card.Footer>
        </Card>
    )
}

export default TeamCard